import React, { Component } from 'react';
import PropTypes from 'prop-types';

class MemberIdForm extends Component {
  state = {
    memberId: '',
  };

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  handleSubmit() {
    const { onSubmit } = this.props;
    if (onSubmit) {
      onSubmit(this.state);
    }
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.handleSubmit();
    }
  }

  render() {
    const {
      style,
      className,
    } = this.props;

    return (
      <div style={style} className={className}>
        <input
          style={{ width: 110, marginRight: 40 }}
          className="form-control di"
          placeholder="Member ID"
          ref={(el) => { this.memberIdRef = el; }}
          onChange={
            () => this.setState({
              memberId: this.memberIdRef.value,
            })
          }
          type="text"
        />
        <button
          type="button"
          onClick={this.handleSubmit}
          onKeyPress={this.handleKeyPress}
          className="btn btn--a"
        >
          Meklēt
        </button>
      </div>
    );
  }
}

MemberIdForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

MemberIdForm.defaultProps = {
  className: '',
  style: {},
};

export default MemberIdForm;
